﻿<template>
    <div class="row">
        <div class="col-xs-0 col-sm-1 col-md-4 col-lg-6 col-xl-8"></div>
        <div class="col-xs-12 col-sm-11 col-md-8 col-lg-6 col-xl-4">
            <div class="column" style="height: 100vh">
                <div class="col-4"></div>
                <div class="col-8">
                    <div class="flex justify-center items-center" style="height: 100%">
                        <img :src="scoringLogo" alt="" class="justify-center dimmed-image compact-logo" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import scoringLogo from '@/assets/scoringlogo.png'
</script>

<style scoped lang="sass">
.dimmed-image
    opacity: 0.2

.compact-logo
    height: 40%
</style>
